<template>
  <div class="d-flex flex-column flex-md-row w-100 radius-6 box-shadow-light-aff border-form overflow-hidden pb-3 pb-md-0">
    <div class="mr-md-3 mr-0 mb-3 mb-md-0 flex-shrink-0" :class="$is_mobile_view ? 'w-100 overflow-hidden' : 'w-200px'" style="max-height: 200px;">
      <img :src="product.image_url" class="img-fit">
    </div>
    <div class="w-100 d-flex flex-column flex-md-row py-md-3 pr-md-3 pr-3 pl-3 pl-md-0">
      <div class="w-100 mb-3 mb-md-0">
        <p class="mb-1" :class="$is_mobile_view ? 'body-2-4' : 'sub-heading-1-2'">{{ product.name }}</p>
        <p class="mb-2 html-desc text-truncate-2" style="max-height: 38px" :class="$is_mobile_view ? 'body-3' : 'body-2'" v-html="product.description"></p>
        <ul class="pl-3 my-2 mb-2">
          <li v-if="$isNotEmptyV2(product.display.routeType)" class="mb-0" :class="$is_mobile_view ? 'body-3-1' : 'body-2-1'">{{ product.display.routeType }}</li>
          <li v-if="$isNotEmptyV2(product.display.passenger)" class="mb-0" :class="$is_mobile_view ? 'body-3-1' : 'body-2-1'">{{ product.display.passenger }}</li>
        </ul>
        <p class="mb-0 font-lato ls-0-25 text-14 text-green cursor-pointer underline" @click="openDetail()">See More</p>
      </div>
      <div class="d-flex flex-row flex-md-column align-items-end  justify-content-between pl-md-4">
        <div class="text-md-right ">
          <p class="mb-1 text-orange font-lato lh-1" :class="$is_mobile_view ? 'text-22' : 'text-26'">{{ $formatCurrency(product.price) }}</p>
          <p class="mb-md-1 mb-0 body-3-1 lh-1">/ {{product.unit.unit}}</p>
        </div>
        <div>
          <p v-if="savedProduct > 0" class="mb-0 w-100 text-center text-green font-lato text-12 mb-1">({{ `${savedProduct} passenger added` }})</p>
          <button class="g-btn g-btn-secondary g-btn-md px-4 d-flex align-items-center" @click="openDetail()">
            <template v-if="savedProduct === 0">
              <svg class="lh-1 mr-1" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="#FFF"/>
              </svg>
              <span class="ml-1">Add</span>
            </template>
            <template v-else>
              <svg class="lh-1 mr-1" width="12" height="12" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.37 0.29L17.71 2.63C18.1 3.02 18.1 3.65 17.71 4.04L15.88 5.87L12.13 2.12L13.96 0.29C14.15 0.1 14.4 0 14.66 0C14.92 0 15.17 0.09 15.37 0.29ZM0 14.25V18H3.75L14.81 6.94L11.06 3.19L0 14.25ZM2.92 16H2V15.08L11.06 6.02L11.98 6.94L2.92 16Z" fill="#FFF"/>
              </svg>
              <span class="ml-1">Manage</span>
            </template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

  export default {
    props: ['product'],
    computed:{
      ...mapGetters(['getBeCartRoom']),
      savedProduct(){
        let total = 0;

        this.getBeCartRoom.forEach(room => {
          room.guest.forEach(guest => {
            if(this.$isNotEmptyV2(guest.products)){
              const matchProduct = guest.products.find(product => product.data.id === this.product.id);
              if(matchProduct) total += matchProduct.qty;
            }
          })
        });
        
        return total;
      }
    },
    methods:{ 
      openDetail(){
        this.$emit('detail', this.product)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/TransportServicesProduct.vue